import { useSwitchGetCommentScope } from "@/hooks/useComment";
import { CommentScope } from "@/interfaces/comment.interface";
import { batchCommentLoadingState } from "@/stores/comment";
import { Spin } from "antd";
import { css } from "emotion";
import React from "react";
import { useRecoilValue } from "recoil";
import MyLazyCommentList from "./components/CommentList/MyLazyCommentList";
import styles from "./styles.module.less";

const { container } = styles;

interface IProps {
  fatherId: string;
  scope: CommentScope;
  lazyLoading: boolean;
  url?: string;
}

const LazyComment: React.FC<IProps> = ({ fatherId, scope, lazyLoading }) => {
  const bLoading = useRecoilValue(batchCommentLoadingState);
  const comments = useSwitchGetCommentScope(scope, fatherId);
  return (
    <div
      className={`${container} ${css`
    .ant-list-pagination {
      margin: ${comments?.count ? undefined : 0}
    `}`}
    >
      <Spin spinning={bLoading || lazyLoading}>
        <MyLazyCommentList fatherId={fatherId} scope={scope} />
      </Spin>
    </div>
  );
};

export default LazyComment;
